import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResetPassword, SendVerifyCode, VerifyAccountForResetPassword, VerifyCode } from "../api/auth";
import { ContactType } from "../api/models/ContactType";
import { VerifyAccountForResetPasswordType } from "../api/models/VerifyAccountForResetPasswordType";
import { SendVerifyCodeAction } from "../api/models/SendVerifyCodeAction";

interface ForgetPasswordState {
  email: string;
  verificationCode: string;
  newPassword: string;
}

// Define the initial state using that type
const initialState: ForgetPasswordState = {
  email: "",
  verificationCode: "",
  newPassword: "",
};

export const forgetPasswordSlice = createSlice({
  name: "forget-password",
  initialState: initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },

    setVerificationCode: (state, action: PayloadAction<string>) => {
      state.verificationCode = action.payload;
    },

    setPassword: (state, action: PayloadAction<string>) => {
      state.newPassword = action.payload;
    }
  },
});

export const verifyAccountForResetPassword = (email: string) => {
  return async (dispatch: any) => {
    try {
      await VerifyAccountForResetPassword(
        ContactType.email,
        VerifyAccountForResetPasswordType.email,
        email
      );
      await SendVerifyCode(
        SendVerifyCodeAction.resetPassword,
        ContactType.email,
        email
      );

      dispatch(forgetPasswordActions.setEmail(email));
    } catch (error) {
      throw error;
    }
  };
};

export const sendVerifyCode = () => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const email = state.forgetPassword.email;
    try {
      await SendVerifyCode(
        SendVerifyCodeAction.resetPassword,
        ContactType.email,
        email
      );
    } catch (error) {
      throw error;
    }
  };
};

export const verifyCode = (pin: string) => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const email = state.forgetPassword.email;
    try {
      await VerifyCode(
        SendVerifyCodeAction.resetPassword,
        ContactType.email,
        email,
        pin
      );
      dispatch(forgetPasswordActions.setVerificationCode(pin));
    } catch (error) {
      throw error;
    }
  };
};

export const resetPassword = (password: string) => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const email = state.forgetPassword.email;
    const pin = state.forgetPassword.verificationCode
    try {
      await ResetPassword(
        SendVerifyCodeAction.resetPassword,
        ContactType.email,
        email,
        pin,
        password
      );
      dispatch(forgetPasswordActions.setPassword(password));
    } catch (error) {
      throw error;
    }
  };
};

export const forgetPasswordActions = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;
